export const countryCodes = {
  "852": "+852",
  "86": "+86"
};

export const noOfPeople = {
  1: "1",
  2: "2",
  3: "3",
  4: "4"
};

export const todayTimeSlots = {
  "9800": "time.10",
  "9801": "time.11",
  "9802": "time.12",
  "9803": "time.13",
  "9804": "time.14",
  "9805": "time.15",
  "9806": "time.16",
  "9807": "time.17",
  "9808": "time.18",
  "9809": "time.19"
};

export const timeSlots = {
  "0": "time.10",
  "1": "time.11",
  "2": "time.12",
  "3": "time.13",
  "4": "time.14",
  "5": "time.15",
  "6": "time.16",
  "7": "time.17",
  "8": "time.18",
  "9": "time.19"
};

export const titles = {
  ms: "salutation.ms",
  mr: "salutation.mr",
  mrs: "salutation.mrs"
};
